import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      variant: 'flex.column.start',
      width: '100%',
    };

    this.productRow = {
      ...this.wrapper,
      minHeight: ['113px', 20],
      overflow: 'hidden',
    };

    this.title = {
      variant: 'text.h5',
    };

    this.variant = {
      color: 'mediumDarkGray',
      mt: 1,
    };

    this.colorCountVerbiage = {
      color: 'mediumDarkGray',
      mt: 6,
    };

    this.newPrice = {
      variant: 'text.base',
      color: 'red',
      mr: 4,
      fontSize: ['18px', '24px'],
    };

    this.compareAtPrice = {
      variant: 'text.base',
      textDecoration: 'line-through',
      color: 'mediumDarkGray',
      fontSize: ['18px', '24px'],
    };

    this.price = {
      variant: 'text.base',
      fontSize: ['18px', '24px'],
    };

    this.loader = {
      height: ['20px', '22px'],
      svg: {
        height: '100%',
        color: 'gray',
      },
    };
  })()
);
